var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "work-order-detail" }, [
    _vm.activeBigImg
      ? _c("div", { staticClass: "big-img" }, [
          _c("div", { staticClass: "close-img" }, [
            _c("img", {
              staticClass: "des-img",
              attrs: { src: _vm.bigImgUrl, alt: "" }
            }),
            _vm._v(" "),
            _c("img", {
              staticClass: "close",
              attrs: { src: require("../../assets/img/close.png"), alt: "" },
              on: { click: _vm.closeBigImg }
            })
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "left" }, [
      _c("div", { staticClass: "left-top" }, [
        _vm.activeColor == 1 && [1, 2, 4].indexOf(_vm.detailData.status) > -1
          ? _c(
              "div",
              { staticClass: "status-but" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { size: "small" },
                    on: {
                      click: function($event) {
                        return _vm.changeState(0)
                      }
                    }
                  },
                  [_vm._v("关 闭")]
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.activeColor == 1 && _vm.detailData.status == 3
          ? _c(
              "div",
              { staticClass: "status-but" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { size: "small" },
                    on: {
                      click: function($event) {
                        return _vm.changeState(99)
                      }
                    }
                  },
                  [_vm._v("确认已解决")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { size: "small" },
                    on: {
                      click: function($event) {
                        return _vm.changeState(4)
                      }
                    }
                  },
                  [_vm._v("未解决")]
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("h3", { staticClass: "left-title" }, [
          _vm._v("\n        工单号 "),
          _c("span", { staticClass: "order-num" }, [
            _vm._v(_vm._s(_vm.detailData.exceptionOrderNo))
          ]),
          _c("img", {
            attrs: {
              src: require("./../../assets/img/connaction.png"),
              alt: ""
            }
          }),
          _c(
            "span",
            {
              staticClass: "connect-num",
              on: {
                click: function($event) {
                  return _vm.goOrder(_vm.detailData.businessKey)
                }
              }
            },
            [_vm._v(_vm._s(_vm.detailData.businessKey))]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "status" }, [
          _vm._v("\n        处理状态： "),
          _c("span", { staticClass: "doing" }, [
            _vm._v(_vm._s(_vm.detailData.statusDesc))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "type" }, [
          _vm._v("\n        工单类型： "),
          _c("span", [_vm._v(_vm._s(_vm.detailData.exceptionTypeDesc))])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "des" }, [
          _c("div", { staticClass: "des-title" }, [_vm._v("工单描述：")]),
          _vm._v(" "),
          _c("div", { staticClass: "des-content" }, [
            _vm._v(_vm._s(_vm.detailData.description))
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "img" },
          [
            _vm._v("\n        图片说明：\n        "),
            _vm._l(_vm.detailData.exceptionImageUrls, function(item, index) {
              return _c("img", {
                key: index,
                attrs: { src: item, alt: "" },
                on: {
                  click: function($event) {
                    return _vm.bigImg(index)
                  }
                }
              })
            })
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "img" }, [
          _vm._v("\n        视频说明：\n        "),
          _vm.detailData.videoList && _vm.detailData.videoList.length > 0
            ? _c(
                "div",
                _vm._l(_vm.detailData.videoList, function(item, index) {
                  return _c(
                    "video",
                    {
                      staticClass: "avatar video-avatar",
                      staticStyle: { width: "128px", "margin-right": "10px" },
                      attrs: { src: item, controls: "controls" }
                    },
                    [
                      _vm._v(
                        "\n            您的浏览器不支持视频播放\n          "
                      )
                    ]
                  )
                }),
                0
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "lastAddImg" },
          [
            _c("span", [_vm._v("补充图片：")]),
            _vm._v(" "),
            _c(
              "el-upload",
              {
                staticClass: "img-upload",
                attrs: {
                  action: _vm.addImgUrl,
                  headers: _vm.headers,
                  "list-type": "picture-card",
                  "auto-upload": true,
                  limit: 5,
                  "before-upload": _vm.beforeAvatarUpload,
                  "on-success": _vm.successImg,
                  "file-list": _vm.fileList,
                  "on-exceed": _vm.exce
                },
                scopedSlots: _vm._u([
                  {
                    key: "file",
                    fn: function(ref) {
                      var file = ref.file
                      return _c("div", {}, [
                        _c("img", {
                          staticClass: "el-upload-list__item-thumbnail",
                          attrs: { src: file.url, alt: "" }
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "el-upload-list__item-actions" },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "el-upload-list__item-preview",
                                on: {
                                  click: function($event) {
                                    return _vm.handlePictureCardPreview(file)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "el-icon-zoom-in" })]
                            ),
                            _vm._v(" "),
                            !_vm.build.disabled
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "el-upload-list__item-delete",
                                    on: {
                                      click: function($event) {
                                        return _vm.handleRemove(
                                          file,
                                          _vm.fileList
                                        )
                                      }
                                    }
                                  },
                                  [_c("i", { staticClass: "el-icon-delete" })]
                                )
                              : _vm._e()
                          ]
                        )
                      ])
                    }
                  }
                ])
              },
              [
                _c("i", {
                  staticClass: "el-icon-plus",
                  attrs: { slot: "default" },
                  slot: "default"
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "el-dialog",
              {
                attrs: {
                  visible: _vm.build.dialogVisible,
                  modal: true,
                  "modal-append-to-body": false
                },
                on: {
                  "update:visible": function($event) {
                    return _vm.$set(_vm.build, "dialogVisible", $event)
                  }
                }
              },
              [
                _c("img", {
                  attrs: {
                    width: "100%",
                    src: _vm.build.dialogImageUrl,
                    alt: ""
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "el-dialog",
              {
                attrs: {
                  visible: _vm.deleteDialogVisible,
                  width: "400px",
                  modal: true,
                  "modal-append-to-body": false,
                  "show-close": false,
                  "custom-class": "delete-modal"
                },
                on: {
                  "update:visible": function($event) {
                    _vm.deleteDialogVisible = $event
                  }
                }
              },
              [
                _c("span", [
                  _c("i", {
                    staticClass: "el-icon-warning-outline warning-icon"
                  }),
                  _vm._v("是否确认删除当前图片？")
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: {
                          click: function($event) {
                            _vm.deleteDialogVisible = false
                          }
                        }
                      },
                      [_vm._v("取 消")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "small" },
                        on: { click: _vm.sureDelete }
                      },
                      [_vm._v("确 定")]
                    )
                  ],
                  1
                )
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "img-info" }, [_vm._v("（最多支持上传5张）")]),
        _vm._v(" "),
        _c("div", { staticClass: "people" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "end" }, [
            _vm._v("\n          最终受理人 "),
            _c("img", {
              attrs: {
                src: require("./../../assets/img/user-icon.png"),
                alt: ""
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "name" }, [
              _vm._v(_vm._s(_vm.detailData.operatorName))
            ]),
            _vm._v(" "),
            _vm.detailData.resolutionTime
              ? _c("div", { staticClass: "time" }, [
                  _c("span", [_vm._v("解决时间")]),
                  _vm._v(
                    " " + _vm._s(_vm.detailData.resolutionTime) + "\n          "
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "first" }, [
            _vm._v("\n          第一受理人 "),
            _c("img", {
              attrs: {
                src: require("./../../assets/img/user-icon.png"),
                alt: ""
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "name" }, [
              _vm._v(_vm._s(_vm.detailData.operatorName))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "build" }, [
            _vm._v("\n          创建人 "),
            _c("img", {
              attrs: {
                src: require("./../../assets/img/user-icon.png"),
                alt: ""
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "name" }, [
              _vm._v(_vm._s(_vm.detailData.createdByName))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "time" }, [
              _c("span", [_vm._v("创建时间")]),
              _vm._v(" " + _vm._s(_vm.detailData.createdAt) + "\n          ")
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "left-bottom" }, [
        _c("h3", [_vm._v("活动日志")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "inp" },
          [
            _c("el-autocomplete", {
              attrs: {
                "fetch-suggestions": _vm.querySearch,
                placeholder: "请输入备注内容"
              },
              on: { select: _vm.handleSelect },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c("span", { attrs: { title: item } }, [
                        _vm._v(_vm._s(item))
                      ])
                    ]
                  }
                }
              ]),
              model: {
                value: _vm.activeContent,
                callback: function($$v) {
                  _vm.activeContent = $$v
                },
                expression: "activeContent"
              }
            }),
            _vm._v(" "),
            _c(
              "el-button",
              { attrs: { size: "small" }, on: { click: _vm.addRemarkContent } },
              [_vm._v("确 定")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "active-list" },
          _vm._l(_vm.detailData.operations, function(item, index) {
            return _c("div", { key: index, staticClass: "list" }, [
              _c("img", {
                attrs: {
                  src: require("./../../assets/img/user-icon.png"),
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "name" }, [
                _vm._v(_vm._s(item.operatorName))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "time" }, [
                _vm._v(_vm._s(item.createdAt))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _vm._v(_vm._s(item.content))
              ])
            ])
          }),
          0
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "time-line" }, [
      _c("span", { staticClass: "span1" }),
      _c("span", { staticClass: "span2" }),
      _c("span", { staticClass: "span3" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0a9c8514", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a9c8514","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/orderForChat/workOrderDetail.vue
// module id = null
// module chunks = 